<template>
  <base-panel
    :asset="asset"
    :hide-print-button="false"
    :asset-module="assetModule"
    :tabs="tabs"
    :last-update="status.lastUpdate"
    :notifications="notifications"
  />
</template>

<script>
import { grammaticalJoin } from '@/services/arrayUtils';
import CoolingMaintenanceTabs from '@/domain/enums/installation/engineering/coolingMaintenance/coolingMaintenanceTabs';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import GeneralTab from '@/domain/components/installation/engineering/coolingMaintenance/general/GeneralTab';
import ParametersTab from '@/domain/components/installation/engineering/coolingMaintenance/parameters/ParametersTab';
import Service from '@/domain/services/installation/engineering/coolingMaintenance/coolingMaintenanceService';
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineering';

export default {
  name: 'CoolingMaintenance',
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
    assetModule: {
      type: Object,
      default: () => ({}),
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BasePanel,
  },
  data: () => ({
    status: {},
  }),
  computed: {
    tabs() {
      return [
        {
          name: CoolingMaintenanceTabs.GENERAL,
          title: this.$t('general.general'),
          component: GeneralTab,
          status: this.status,
        },
        {
          name: CoolingMaintenanceTabs.PARAMETERS,
          title: this.$t('general.parameters'),
          component: ParametersTab,
          status: this.status,
          showTooltip: true,
          tooltipMessage: 'messages.MI023.message',
        },
      ];
    },
  },
  created() {
    this.initListener();
    this.getStatus(true, true);
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    getStatus(showLoading, checkParam) {
      return Service.getStatus(this.assetModule.id)
        .then((response) => {
          this.status = response;
          if (checkParam) {
            this.checkInvalidParam(response);
          }
        })
        .then(() => {
          eventBus.emit(events.refreshDataTab, showLoading);
        });
    },
    checkInvalidParam({ parametersNotConsumedByAlgorithm, noRegisteredGroups, inactiveContacts }) {
      if (parametersNotConsumedByAlgorithm) {
        this.$pushAlert({ code: 'MA091' });
      }
      if (noRegisteredGroups) {
        this.$pushAlert({ code: 'MA093' });
      }
      if (inactiveContacts && inactiveContacts.length > 0) {
        this.$pushAlert({
          code: 'MA110',
          messageParams: {
            0: grammaticalJoin(inactiveContacts),
          },
        });
      }
    },
    initListener() {
      eventBus.on(events.refreshData, this.refreshDataEvent, this);
    },
    removeListener() {
      eventBus.off(events.refreshData, this.refreshDataEvent, this);
    },
    refreshDataEvent({ wait }) {
      wait(this.getStatus());
    },
  },
};
</script>

<style lang="sass" scoped>
  @media print
    ::v-deep .tabs > .tab-content > .tab-pane
      border-bottom: none
</style>
